import { useEffect, FunctionComponent } from 'react'
import { useParams } from 'react-router-dom'
import { User, Heart, CreditCard, DollarSign } from 'react-feather'
import Submenu from '../../components/Submenu'
import DetailOverlayPage from '../../components/DetailOverlay/Container'
import TopBar from '../../components/DetailOverlay/TopBar'
import usePatronStore from '../../stores/patron'
import useAuthStore from '../../stores/auth'

const PatronDetail: FunctionComponent = () => {
  const { getPatron } = usePatronStore()
  const { id } = useParams<{ id: string }>()
  const user = useAuthStore((state) => state.user)
  const isSuperAdmin = user?.role === 'super_admin'
  const patron = usePatronStore((state) => state.patrons[id as string])

  useEffect(() => {
    getPatron(id as string)
  }, [id, getPatron])

  return (
    <DetailOverlayPage>
      <TopBar breadCrumbs={[
        { title: 'Patrons', linkPath: '/patrons' },
        { title: patron ? patron.email : '', linkPath: '' },
      ]} closePath={'/patrons'}
      />
      <Submenu
        basePath={`/patrons/${id}`}
        items={[
          {
            id: 'profile',
            icon: User,
            title: 'Patron Profile',
            subPath: ''
          },
          ...(isSuperAdmin ? [{
            id: 'subscriptions',
            icon: CreditCard,
            title: 'Subscriptions',
            subPath: '/subscriptions'
          }] : []),
          {
            id: 'benefits',
            icon: Heart,
            title: 'Benefits',
            subPath: '/benefits'
          },
          {
            id: 'payments',
            icon: DollarSign,
            title: 'Payments',
            subPath: '/payments'
          }
        ]}
      />
    </DetailOverlayPage>
  )
}

export default PatronDetail
